import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('card-associated-objects-lib', {
  library: 'card-associated-objects-lib'
});
export const SUCCESSFUL_DATA_POLL_TIME = 'successful-data-poll-time';